import { Sparkles } from "lucide-react";
import { SUPPORT_EMAIL } from "@/lib/pricing";

const COLUMNS = [
  { title: "Product", links: [
    { key: "how-it-works", label: "How It Works" },
    { key: "pricing", label: "Pricing" },
    { key: "market-research", label: "Free Tools" },
  ] },
  { title: "Company", links: [
    { key: "about", label: "About" },
    { key: "careers", label: "Careers" },
    { key: "contact", label: "Contact us" },
  ] },
  { title: "Legal", links: [
    { key: "terms", label: "Terms of Service" },
    { key: "privacy", label: "Privacy Policy" },
    { key: "refund", label: "Refund Policy" },
  ] },
  { title: "Support", links: [
    { key: "support", label: "Support center" },
    { key: "faq", label: "FAQ" },
    { key: "guide", label: "Publishing Guide" },
  ] },
];

export const SiteFooter = ({ onNavigate }) => {
  const go = (key) => onNavigate && onNavigate(key);
  return (
    <footer data-testid="site-footer" className="border-t border-stone-800/70 bg-stone-950">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
          <div>
            <div className="klyr-word klyr-metal text-2xl">KLYR</div>
            <div className="klyr-sub text-[8px] mt-0.5">STUDIO</div>
            <p className="mt-4 font-read text-sm text-stone-500 max-w-xs leading-relaxed">
              A creative intelligence studio for publish-ready books — you own every book you make.
            </p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid="footer-support-email"
              className="mt-4 inline-flex items-center gap-2 font-ui text-sm text-steel-300 hover:text-steel-200 transition-colors"
            >
              <Sparkles className="w-4 h-4" /> {SUPPORT_EMAIL}
            </a>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <div className="font-ui text-[11px] uppercase tracking-[0.25em] text-stone-500 mb-4">{col.title}</div>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.key + col.title}>
                    <button
                      data-testid={`footer-link-${l.key}`}
                      onClick={() => go(l.key)}
                      className="font-ui text-sm text-stone-300 hover:text-steel-200 transition-colors"
                    >
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-stone-800/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="font-ui text-xs text-stone-600">
            © {new Date().getFullYear()} KLYR Studio · klyrstudio.io
          </div>
          <div className="font-ui text-xs text-stone-600">You own every book you make.</div>
        </div>
      </div>
    </footer>
  );
};
